import { useState } from 'react'

import {
  Box,
  Button,
  Checkbox,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import { useUpdateUser } from '@/react-query/user'

export const TabPrestartModal = ({
  isOpen,
  onClose,
  startRecordingWithTab,
}: {
  isOpen: boolean
  onClose: () => void
  startRecordingWithTab: () => void
}) => {
  const updateUser = useUpdateUser()

  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false)

  const isChrome =
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
  const isSupportedBrowser = isChrome

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={'xl'}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Record a browser tab</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {isSupportedBrowser ? (
            <>
              <p>🌐&nbsp;&nbsp;Share the tab where your call is happening.</p>
              <br />
              <p>
                🎧&nbsp;&nbsp;It&apos;s OK to use headphones (speakers are OK
                too).
              </p>
              <br />
              <p>🔒&nbsp;&nbsp;No video is recorded.</p>
              <br />
              <p>
                🙇&nbsp;&nbsp;Please always ask for consent before recording.
              </p>
              <Box>
                <Checkbox
                  onChange={(e) => setIsCheckboxChecked(e.target.checked)}
                  mt={12}
                >
                  Don&apos;t show this again
                </Checkbox>
              </Box>
            </>
          ) : (
            <NotSupportedBrowserModal />
          )}
        </ModalBody>
        <ModalFooter>
          {isSupportedBrowser ? (
            <>
              <Button
                onClick={async () => {
                  if (isCheckboxChecked) {
                    await updateUser.mutateAsync({
                      user: {
                        showTabLiveRecordingPopup: false,
                      },
                    })
                  }
                  startRecordingWithTab()
                  onClose()
                }}
                rounded={'1.25rem'}
                variant={'brand-solid'}
              >
                Start recording
              </Button>
              <Button variant={'brand-solid-white'} onClick={onClose}>
                Not now
              </Button>
            </>
          ) : (
            <Button variant={'brand-solid-white'} onClick={onClose}>
              Close
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

const NotSupportedBrowserModal = () => {
  return (
    <Box>
      <p>
        🚫&nbsp;&nbsp;Sorry, your browser is not supported for the tab
        recording. Please use Chrome.
      </p>
    </Box>
  )
}
